// WaiverModal.jsx
import { useState, useEffect } from "react";
import { Modal, Button } from "react-bootstrap";
import axios from "axios";

export default function WaiverModal({ show, onAgreed, seasonId }) {
    const [waiver, setWaiver] = useState(null);
    const [loading, setLoading] = useState(false);

    useEffect(() => {
        if (show && seasonId) {
            axios.get("/api/leagues/waiver/", {
                params: { season_id: seasonId },
                withCredentials: true,
            })
                .then((r) => setWaiver(r.data))
                .catch((error) => {
                    if (error.response?.status === 404) {
                        setWaiver(null);
                        return;
                    }
                    console.error("Error loading waiver:", error);
                    setWaiver(null);
                });
        } else if (!show) {
            setWaiver(null);
        }
    }, [show, seasonId]);

    const handleAccept = async () => {
        setLoading(true);
        const formData = new FormData();
        formData.append("waiver", waiver.id);
        await axios.post("/api/leagues/waiver/sign/", formData, {
            headers: { "Content-Type": "multipart/form-data" },
        });
        setLoading(false);
        onAgreed();
    };

    if (!waiver) return null;

    return (
        <Modal show={show} size="lg" backdrop="static">
            <Modal.Header>
                <Modal.Title>{waiver.title}</Modal.Title>
            </Modal.Header>

            <Modal.Body>
                <div
                    dangerouslySetInnerHTML={{ __html: waiver.body }}
                    style={{ maxHeight: "40vh", overflowY: "auto" }}
                />

            </Modal.Body>

            <Modal.Footer>
                <Button variant="primary" disabled={loading} onClick={handleAccept}>
                    {loading ? "Saving..." : "I Agree"}
                </Button>
            </Modal.Footer>
        </Modal>
    );
}
